import { cva } from '@/styled-system/css';

export const filterChipRootRecipe = cva({
  base: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'center',
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
    },
    boxShadowColor: { base: 'border.action.neutral.default' },
    borderRadius: 'shape.capsule',
    paddingInline: 'Chip.padding.horz',
    paddingBlock: 'Chip.padding.vert',
    backgroundColor: { base: 'bg.action.neutral.default' },
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease, background-color 200ms ease',
    },
    minWidth: '0',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        cursor: 'pointer',
        backgroundColor: {
          _hover: 'bg.action.neutral.hover',
          _active: 'bg.action.neutral.pressed',
        },
        boxShadowColor: {
          _hover: 'border.action.neutral.hover',
          _active: 'border.action.neutral.pressed',
        },
        _after: {
          content: '""',
          position: 'absolute',
          height: 'tapArea.mobile.sm',
          minWidth: 'tapArea.mobile.sm',
          width: '100%',
          left: '0',
          top: '50%',
          marginTop: 'calc(({sizes.tapArea.mobile.sm} / 2) * -1)',
        },
      },
    },
    elevated: {
      true: {
        backgroundColor: { base: 'bg.elevated.action.smallShadow.default' },
      },
      false: {},
    },
    selected: {
      true: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color)',
          _focusVisible: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
        },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: false,
      elevated: true,
      css: {
        backgroundColor: {
          _hover: 'Chip.bg.elevated.hover',
          _active: 'Chip.bg.elevated.pressed',
        },
      },
    },
    {
      disabled: true,
      selected: true,
      css: {
        backgroundColor: { base: 'bg.action.soft.selected.default' },
        boxShadowColor: { base: 'border.action.hero.selected.default' },
      },
    },
    {
      disabled: false,
      selected: true,
      css: {
        backgroundColor: {
          base: 'bg.action.soft.selected.default',
          _hover: 'bg.action.soft.selected.hover',
          _active: 'bg.action.soft.selected.pressed',
        },
        boxShadowColor: {
          base: 'border.action.hero.selected.default',
          _hover: 'Chip.border.selectedHover',
          _active: 'Chip.border.selectedPressed',
        },
      },
    },
    {
      elevated: true,
      disabled: false,
      selected: false,
      css: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.sm}',
          _hover: {
            base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.Chip.elevated.hover}',
            _focusVisible:
              'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.Chip.elevated.hover}, {shadows.focus}',
          },
          _active: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.none}',
          _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
        },
      },
    },
    {
      elevated: true,
      disabled: false,
      selected: true,
      css: {
        boxShadow: {
          base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.sm}',
          _hover: {
            base: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.Chip.elevated.hover}',
            _focusVisible:
              'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.Chip.elevated.hover}, {shadows.focus}',
          },
          _active: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.none}',
          _focusVisible: 'inset 0 0 0 {borderWidths.selected} var(--shadow-color), {shadows.focus}',
        },
      },
    },
  ],
});
